import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export const useTracking = (): void => {
    const location = useLocation();

    useEffect(() => {
        const normalizePath = (path: string): string => {
            if (path.startsWith('/lieferung/')) {
                return path.replace(/\/lieferung\/[^/]+/, '/lieferung/[id]');
            } else if (path.startsWith('/kontraktansicht/')) {
                return path.replace(/\/kontraktansicht\/[^/]+/, '/kontraktansicht/[id]');
            } else if (path.startsWith('/bestellansicht/')) {
                return path.replace(/\/bestellansicht\/[^/]+/, '/bestellansicht/[id]');
            } else if (path.startsWith('/auftragsansicht/')) {
                return path.replace(/\/auftragsansicht\/[^/]+/, '/auftragsansicht/[id]');
            } else if (path.startsWith('/admin/partnerdetails/')) {
                return path.replace(/\/admin\/partnerdetails\/[^/]+/, '/admin/partnerdetails/[id]');
            } else if (path.startsWith('/admin/benutzerdetails/')) {
                return path.replace(/\/admin\/benutzerdetails\/[^/]+/, '/admin/benutzerdetails/[id]');
            }
            return path;
        };

        const modifiedPath = normalizePath(location.pathname);

        window.umami?.track({
            url: modifiedPath,
            title: document.title,
            website: '44e53767-6d77-477b-a051-d61813045534',
        });
    }, [location.pathname]);
};
